/**
 * Normalización de acciones de permiso y nombres de perfil: FUENTE ÚNICA.
 *
 * Absorbe las copias de permission.service, permissions-admin.service, user-context.service,
 * roles.service y usuarios.service.
 */

/** Alias HTTP guardados en Identity y su acción canónica (read/create/update/delete). */
const ACTION_ALIASES: Readonly<Record<string, string>> = {
    get: 'read',
    post: 'create',
    put: 'update',
    patch: 'update',
};

/** Perfil con nombre opcional, tal como lo devuelve Identity. */
interface ProfileNameSource {
    profileName?: string | null;
}

/** Normaliza una acción de Identity a la convención canónica: get→read, post→create, put/patch→update. */
export function normalizePermissionAction(actionRaw: unknown): string {
    const action = String(actionRaw ?? '').toLowerCase().trim();
    return ACTION_ALIASES[action] ?? action;
}

/**
 * Claim canónico `permission:<módulo>:<sección>:<página>:<acción>`: identificadores recortados y en
 * minúsculas, acción normalizada (get→read…). Devuelve cadena vacía si falta alguna parte.
 * FUENTE ÚNICA del claim que consulta `PermissionService.canAccess` y que arma el contexto del usuario.
 */
export function buildPermissionClaim(module: unknown, section: unknown, page: unknown, action: unknown): string {
    const parts = [module, section, page].map((part) => String(part ?? '').trim().toLowerCase());
    const normalizedAction = normalizePermissionAction(action);
    return parts.every(Boolean) && normalizedAction ? `permission:${parts.join(':')}:${normalizedAction}` : '';
}

/** Nombres de perfil recortados, sin vacíos ni duplicados (conserva el orden de aparición). */
export function normalizeProfileNames(results: readonly ProfileNameSource[]): string[] {
    const names = results
        .map((item) => String(item?.profileName ?? '').trim())
        .filter((name) => name.length > 0);

    return [...new Set(names)];
}
